import React, { Component } from 'react';

class Banner extends Component {
	render() {
		return (
			<section className="assessment__banner">
				<div className="container-fluid">
					<h1 className="assessment__banner--heading">Let’s understand <br />your skin needs first</h1>
				</div>
			</section>
			);
	}
}


export default Banner;